import * as React from 'react';
import { PinCard } from './PinCard';
import styles from './Pins.module.css';
import { DigitalMapPin } from 'models/digitalMap';
import { useSelector } from 'react-redux';
import { selectDigitalMap } from 'ducks/universal/digitalMap';

interface Props {
  pinKeys: string[];
  onCloseChat: () => void;
}
export const Pins = React.forwardRef<HTMLDivElement, Props>(({ pinKeys, onCloseChat }, ref) => {
  const digitalMap = useSelector(selectDigitalMap);

  const pins = pinKeys
    .map((pinKey) => digitalMap?.pins.find((p) => p.key === pinKey))
    .filter((pin): pin is DigitalMapPin => pin !== undefined);

  const carouselRef = React.useRef<HTMLDivElement>(null);
  const [hasOverflow, setHasOverflow] = React.useState(true);

  React.useEffect(() => {
    const el = carouselRef.current;
    if (el) {
      setHasOverflow(el.scrollWidth > el.clientWidth);
    }
  }, [pins]);

  const isSingle = pins.length === 1;
  const isDoubleWide = pins.length === 2 && !hasOverflow;

  return (
    <div className={styles['container']} ref={ref}>
      <main className={styles['cards']}>
        <div
          className={styles['carousel']}
          style={{ justifyContent: pins.length > 1 ? 'flex-start' : 'center' }}
          ref={carouselRef}
        >
          {pins.map((pin) => (
            <PinCard
              pin={pin}
              key={pin.key}
              onCloseChat={onCloseChat}
              isSingle={isSingle}
              isDoubleWide={isDoubleWide}
            />
          ))}
          {hasOverflow && <div className={styles.spacer} />}
        </div>
      </main>
    </div>
  );
});
